import request from 'Request'
import { updateEncounter } from 'Store/encounters'

const CommentService = {
  async get({ commentId }) {
    return request.get('/comments/get', { params: { commentId } })
  },
  async list({ encounterId }) {
    return request.post('/comments/list', {
      encounterId
    })
  },
  async create({ text, encounterId }) {
    // TODO: This is not needed when websocket is fixed on dev/stage
    updateEncounter(encounterId)
    return request.put('/comments/create', { text, encounterId })
  }
}

export default CommentService
